import { ITeachingBubbleStyles } from "office-ui-fabric-react";
import { AppLayoutSettings } from "../../common/styles/common.styles";

/**
 * Common Styles applied to Teaching Bubble
 */
export const getTeachingbubbleStyles  = (): Partial<ITeachingBubbleStyles> => {
    const styles: Partial<ITeachingBubbleStyles> = {
        root: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        bodyContent:{
            padding:'10px 16px 0px 16px'
        },
        body:{
            paddingRight:'5px'
        },
        subText:{
            fontSize: AppLayoutSettings.AppFontSize.mediumFontSizePx
        }
    }
    return styles;
}